<template>
  <div
    class="inventoryCard-container"
    :style="{
      backgroundImage: `url(${imgUrl})`
    }"
  >
    <div class="top">
      <div class="total-container" @click="handleClick">
        <a-statistic
          :title="title"
          :value="now"
          :valueStyle="{
            fontSize: '28px',
            lineHeight: '30px',
            textAlign: 'center',
            color: 'rgba(0,0,0,.65)'
          }"
        ></a-statistic>
      </div>
      <div class="typeCount-container">
        <!-- <a-space v-if="inventoryType === 'software' || inventoryType === 'hardware'" :size="12">
          <a-statistic
            title="已到期"
            :value="90"
            :valueStyle="{
              fontSize: '14px',
              lineHeight: '14px',
              textAlign: 'center',
              color: '#ff5b73'
            }"
          ></a-statistic>
          <a-statistic
            title="1月内到期"
            :value="90"
            :valueStyle="{
              fontSize: '14px',
              lineHeight: '14px',
              textAlign: 'center',
              color: '#fa6400'
            }"
          ></a-statistic>
          <a-statistic
            title="3月内到期"
            :value="90"
            :valueStyle="{
              fontSize: '14px',
              lineHeight: '14px',
              textAlign: 'center',
              color: '#f7b500'
            }"
          ></a-statistic>
        </a-space> -->

        <cloud-server-icon
          v-if="inventoryType === 'host'"
          style="font-size: 42px; color: #8bcfff82"
        ></cloud-server-icon>

        <service-icon
          v-else-if="inventoryType === 'service'"
          style="font-size: 42px; color: #7adcff82"
        ></service-icon>
      </div>
    </div>

    <div class="bottom">
      <div
        :class="{
          'compare-container': true,
          'compare-container_down': diff < 0
        }"
      >
        <span style="color: rgba(0,0,0,.45); vertical-align: text-top">对比上月</span>
        <a-tooltip>
          <div slot="title">
            <div>上月数量：{{last}}</div>
          </div>
          <down-icon v-if="diff < 0" style="margin: 0 2px 0 6px; vertical-align: text-bottom"></down-icon>
          <up-icon v-else style="margin: 0 2px 0 6px; vertical-align: text-bottom;"></up-icon>
          <span style="font-size: 13px; vertical-align: top">{{ compareRate }}%</span>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getHardwareCount,
  getServiceCount,
  getSoftwareCount,
  getHostCount
} from '@/api/inventory.js'
import UpIcon from '@/components/icon/UpIcon.vue'
import DownIcon from '@/components/icon/DownIcon.vue'
import CloudServerIcon from '@/components/icon/CloudServerIcon.vue'
import ServiceIcon from '@/components/icon/ServiceIcon.vue'

export default {
  name: 'InventoryCard',
  components: {
    UpIcon,
    DownIcon,
    CloudServerIcon,
    ServiceIcon
  },
  props: {
    imgUrl: {
      type: String
    },
    title: {
      type: String
    },
    inventoryType: {
      type: String
    }
  },
  data () {
    return {
      last: 0,
      now: 0,
      compareRate: 0,
      diff: 0
    }
  },
  computed: {
    fetchFunc () {
      if (this.inventoryType === 'hardware') return getHardwareCount
      if (this.inventoryType === 'software') return getSoftwareCount
      if (this.inventoryType === 'host') return getHostCount
      return getServiceCount
    },
    routerName () {
      if (this.inventoryType === 'hardware') return 'HardwareInventory'
      if (this.inventoryType === 'software') return 'SoftwareInventory'
      if (this.inventoryType === 'host') return 'HostInventory'
      return 'ServiceInventory'
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.fetchFunc().then(res => {
        if (res.data) {
          this.last = res.data.data.find(item => item.name === 'last').value
          this.now = res.data.data.find(item => item.name === 'now').value
        } else {
          this.last = 0
          this.now = 0
        }
        this.diff = this.now - this.last
        if (this.diff !== 0 && this.last !== 0) {
          this.compareRate = (Math.abs(this.diff) / this.last * 100).toFixed(1) * 1
        } else this.compareRate = 0
      })
    },
    handleClick () {
      this.$router.push({ name: this.routerName })
    }
  }
}
</script>

<style lang="less" scoped>
.inventoryCard-container {
  height: 128px;
  border-radius: 6px;
  overflow: hidden;
  padding: 6px 24px;
  background-repeat: no-repeat;
  background-size: 100% 100%;

  .top {
    padding-top: 12px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;

    .total-container {
      padding: 0 0 0 12px;
      z-index: 999;
      cursor: pointer;
      :deep(.ant-statistic-title) {
        font-size: 13px;
        color: rgba(0, 0, 0, .65);
      }
    }
    .typeCount-container {
      :deep(.ant-statistic-title) {
        font-size: 11px;
      }
    }
  }

  .bottom {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: flex-end;
    padding-left: 12px;

    .compare-container {
      font-size: 11px;
      color: rgb(247, 87, 87);
      padding-bottom: 3px;
    }
    .compare-container_down {
      color: rgb(62, 163, 40);
    }
  }
}
</style>
